<template>
  <div class="changeData">
    <vm-table
        ref="vmTable"
        height="68vh"
        :filter.sync="filter"
        module="basic"
        url="sAPBusinessDataChange/getWithPage">
      <template slot="adSearch">
        <div class="vm-search" style="display: flex;flex-direction: row;align-items: center;">
          <div style="font-size: 14px;margin-right: 10px;width: 92px;text-align: right">业务类型:</div>
          <el-radio-group v-model="filter.busindessType" @change="handleChange">
            <el-radio label="">全部</el-radio>
            <el-radio label="1" style="width: 80px">销售订单</el-radio>
            <el-radio label="2" style="width: 80px">生产订单</el-radio>
            <el-radio label="3" style="width: 70px">发货单</el-radio>
            <el-radio label="4" style="width: 80px">采购订单</el-radio>
            <el-radio label="5" style="width: 70px">拣配单</el-radio>
          </el-radio-group>
        </div>
        <div class="vm-search" style="display: flex;flex-direction: row;align-items: center;margin: 10px 0">
          <div style="font-size: 14px;margin-right: 10px;width: 92px;text-align: right">数据变化类型:</div>
          <el-radio-group v-model="filter.dataChangeType" @change="handleChange">
            <el-radio label="">全部</el-radio>
            <el-radio label="1" style="width: 80px">新建</el-radio>
            <el-radio label="2" style="width: 80px">修改</el-radio>
            <el-radio label="4" style="width: 70px">删除</el-radio>
            <el-radio label="3" style="width: 80px">确认交期</el-radio>
          </el-radio-group>
        </div>
        <div class="vm-search" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px">
          <div style="font-size: 14px;margin-right: 10px;width: 92px;text-align: right">状态:</div>
          <el-radio-group v-model="filter.status" @change="handleChange">
            <el-radio label="">全部</el-radio>
            <el-radio label="0" style="width: 80px">待同步</el-radio>
            <el-radio label="1" style="width: 80px">成功</el-radio>
            <el-radio label="2" style="width: 70px">失败</el-radio>
          </el-radio-group>
        </div>
        <div class="vm-search">
          <vm-search label="订单编号">
            <el-input v-model.trim="filter.busindessNO" clearable/>
          </vm-search>
          <vm-search label="数据变化时间:">
            <div class="block">
              <el-date-picker
                  v-model="filter.dataChangeTimeBegin"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 135px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.dataChangeTimeEnd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 150px;"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" prop="busindessNO" label="订单编号"/>
      <el-table-column align="center" prop="busindessTypeName" label="业务类型" width="80"/>
      <el-table-column align="center" prop="statusName" label="状态" width="80"/>
      <el-table-column align="center" prop="dataChangeTypeName" label="数据变化类型" width="100"/>
      <el-table-column align="center" prop="dataChangeTime" label="数据变化时间"/>
      <el-table-column align="center" prop="sAPVar" label="SAPVar"/>
      <el-table-column align="center" prop="retryCount" label="重试次数" width="80"/>
      <el-table-column align="center" prop="handledTime" label="处理时间"/>
      <el-table-column align="center" prop="createdTime" label="创建时间"/>
      <el-table-column align="center" prop="note" label="备注"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "BusinessDataChangeList",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          busindessNO: "",
          busindessType: "",
          dataChangeType: "",
          status: "",
          dataChangeTimeBegin: "",
          dataChangeTimeEnd: "",
        },
      };
    },
    mounted() {
      this.initTime();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleChange() {
        this.getList(1);
      },
      initTime() {
        this.filter.dataChangeTimeEnd = this.getFormatDate(new Date());
        this.filter.dataChangeTimeBegin = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
        this.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
    },
  };
</script>
<style lang="scss">
  .changeData{
    .vm-search-com .vm-search-label[data-v-658ba3ef]{
      font-size: 14px!important;
    }
    .vm-search-com[data-v-658ba3ef]:nth-child(2){
      margin-left: 10px;
    }
  }
</style>
